import { useCallback, useState } from 'react';
import { TextInputField } from 'ui';
import { EyeIcon, EyeOffIcon } from 'ui/icons';

interface PasswordFieldProps {
  name: string;
  label: string;
  placeholder: string;
}

const PasswordField = ({ name, label, placeholder }: PasswordFieldProps) => {
  const [type, setType] = useState<'password' | 'text'>('password');

  const handleToggleType = useCallback(() => {
    setType(type => (type === 'password' ? 'text' : 'password'));
  }, []);

  return (
    <div className="password-wrapper relative">
      <TextInputField name={name} label={label} type={type} placeholder={placeholder} />
      <button className="absolute right-1 bottom-3.5" onClick={handleToggleType}>
        <img src={type === 'password' ? EyeIcon : EyeOffIcon} alt="show" />
      </button>
    </div>
  );
};

export default PasswordField;
